import { render, staticRenderFns } from "./rfq-tab-part.vue?vue&type=template&id=6ca6a6e8"
import script from "./rfq-tab-part.vue?vue&type=script&lang=js"
export * from "./rfq-tab-part.vue?vue&type=script&lang=js"
import style0 from "./rfq-tab-part.vue?vue&type=style&index=0&id=6ca6a6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports